<template>
  <el-dialog
    :title="this.$t('productPrice.title.confirmPrice')"
    :visible.sync="dialogVisible"
    width="1200px"
    @close="closeDialog"
  >
    <el-row class="rowPrice">
      <el-col :style="{ width: '20%', textAlign: 'right', height: '30px', lineHeight: '30px' }">{{
        this.$t('productPrice.label.periodName')
      }}</el-col>
      <el-col :style="{ width: '20%' }">
        <el-input v-model="this.importDataResult.periodName" :disabled="true"></el-input>
      </el-col>
      <el-col :style="{ width: '20%', textAlign: 'right', height: '30px', lineHeight: '30px' }">{{
        this.$t('productPrice.label.projectName')
      }}</el-col>
      <el-col :style="{ width: '20%' }">
        <el-input v-model="this.importDataResult.projectName" :disabled="true"></el-input>
      </el-col>
    </el-row>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :setting="false"
        :paging="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="index" :title="$t('productPrice.table.sortNo')" width="60">
        </vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading" @click="addSure()">{{
        $t('dialog.confirm')
      }}</el-button>
      <el-button :loading="loading" @click="dialogVisible = false">{{
        $t('dialog.cancel')
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/productCenter/productPrice';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    name: 'importResult',
    mixins: [tableMixins],
    components: {
      SiruiTable,
    },
    props: {
      importDataResult: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      //表格显示字段
      columnListDefault() {
        return [
          //原料编码
          {
            field: 'productCode',
            title: this.$t('productPrice.column.productCode'),
            visible: true,
          },
          //原料名称
          {
            field: 'productName',
            title: this.$t('productPrice.column.productName'),
            visible: true,
          },
          //规格型号
          {
            field: 'productSpec',
            title: this.$t('productPrice.column.productSpec'),
            visible: true,
          },
          //当前价格
          {
            field: 'productPrice',
            title: this.$t('productPrice.column.productPrice'),
            visible: true,
          },
          //价格状态
          {
            field: 'priceStatus',
            title: this.$t('productPrice.column.priceStatus'),
            visible: true,
            dictType: 'produce_product_status',
          },
        ];
      },
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
      };
    },
    mounted() {
      //this.getData();
    },
    methods: {
      async getData() {
        if (!this.importDataResult.periodName) {
          return this.tips('noPeriodName', 'error');
        }
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = JSON.parse(JSON.stringify(this.importDataResult));
        let obj = { priceStatus: '002' };
        params = Object.assign(params, { pageNum, pageSize }, obj);
        let res = await this.$axios.post(API.LIST_PRODUCTPRICE_BY_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async addSure() {
        let params = this.importDataResult;
        let res = await this.$axios.post(API.LIST_PRODUCTPRICE_CONFIRM, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.dialogVisible = false;
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      openDialog() {
        this.dialogVisible = true;
      },
      closeDialog() {
        // 弹窗关闭
        this.dialogVisible = false;
        //this.$emit('updateTableData', this.exportDetail());
      },

      exportDetail() {},
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`productPrice.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
<style scoped>
  .rowPrice {
    text-align: center;
  }
</style>
